module.exports = __webpack_public_path__ + "img/1528874106.fc4e7d58.jpg";